let HeCustomAction = require('./hecore/HeCustomAction')
let HeDisplayUtil = require('./hecore/HeDisplayUtil')
let Localization = require('./hecore/HeLocalization')

// TODO: 

// 临时
he_log_info = cc.log
he_log_warning = cc.warn
he_log_error = cc.error

he = {
    HeDisplayUtil: HeDisplayUtil.HeDisplayUtil,
    HeBezierTo: HeDisplayUtil.HeBezierTo, 
    HeContentSizeTo: HeDisplayUtil.HeContentSizeTo,   

    HeCircleMoveToAction: HeCustomAction.HeCircleMoveToAction,
    HeBezierEaseAction: HeCustomAction.HeBezierEaseAction,
    HeBezierRotationTo: HeCustomAction.HeBezierRotationTo,

    Localization: Localization
}

he.StartupConfig = {}
he.StartupConfig.getInstance = function () {
    return this;
}

he.StartupConfig.getPlatformName = function () {
    return 'h5'
}

he.HeResPathUtils = {}
he.HeResPathUtils.getUserDataPath = function () {
    return ''
}

he.StartupConfig.isLocalDevelopMode = function () {
    return window.isLocalDevelopMode
}

he.StartupConfig.getDynamicHost = function () {}

he.MetaInfo = {
    getSdCardRoot() { },
    getIpAddress() { },
    getPhoneNum() { },
    getImei() { },
    getSimCountry() { },
    getNetOperatorName() { },
    getNetOperatorNum() { },
    getIccid() { },
    getImsi() { },
    getFilesDir() { },
    getCrashLogDir() { },
    getPackageName() { },
    getApkVersion() { },
    getApkVersionCode() { },
    getMacAddress() { },
    getLanguage() {
        // TODO: 完善多语言的获取方式
        return "zh_CN"
    },
    getCountry() { },
    getTimeZone() { },
    getOsVersion() { },
    getDeviceName() { },
    getMachineType() { },
    isJailbreak() { },
    getDeviceModel() { },
    getNetworkInfo() { },
    getDensityIndependentPixel() { },
    getDotsPerInch() { },
    getResolution() { },
    getResolutionHeight() { },
    getResolutionWidth() { },
    getDeviceSerialNumber() { },
    getUdid() { },
    getSdk() { },
    getSimNetworkType() { },
    getSimPhoneType() { },
    getCpuAbi() { },
    isCpuArmv7a() { },
    getSessionUuid() { },
    getInstallKey() { },
    isNewInstalled() { },
    isRoot() { },
    getLocalIpAddress() { },
    getUuid() { },
    getExternalStorageDirectory() { },
    getBeijingTimeStr() { },
}
he.MetaInfo.getInstance = function () { return this }


he.HERandomObject = cc.Class.extend({
    ctor() {
        this.seed = 0
    },

    randSeed(seed = 0) {
        this.seed = seed
    },

    rand(a, b) {
        if ((a || a === 0) && (b || b === 0)) {
            if (a > b) { c = a; a = b; b = c; }
            return Math.floor(this.rand() * (b - a + 1)) + a
        } else {
            this.seed = (9301 * this.seed + 49297) % 233280
            return this.seed / 233280
        }
    }
})

he.HERandomObject.create = function() {
    return new he.HERandomObject()
}

he.NodeType = {
    OTHER_DATA:1,
    BRANCH_DATA:2,
    LV_DATA:3    
}   
oc = {}
oc.HeAppController = {}
oc.HeGspDcAgent = {
    getInstance(){
        
    }
}

// TODO: HeBrightness
he.HeBrightness = he.HeBrightness || {}
he.HeBrightness.create = function () {
    cc.warn("HeBrightness need to implate")
    return new cc.ActionInterval(0.2);
}
he.GroupRenderPassAction = he.GroupRenderPassAction || cc.ActionInterval.extend({
    ctor: function() {
        cc.Action.prototype.ctor.call(this);
    },
    update: function() {
    }
})
he.GroupRenderPassAction.create = function() {
    return new he.GroupRenderPassAction()
}
